import { RawAnchor } from '@components/anchor'
import { AppStoreRating } from '@components/app-store-rating'
import { Container } from '@components/layout/grid'
import type { SectionOfPressBannersFragment } from '@graphql/fragments/SectionOfPressBannersFragment.graphql'
import variables, { type Variable } from '@styles/variables'
import Image from 'next/image'
import type { FunctionComponent } from 'react'

import styles from './section-of-press-banners.module.scss'

export const SectionOfPressBanners: FunctionComponent<
    SectionOfPressBannersFragment
> = ({
    icons,
    appStoreRating,
    numberOfReviews,
    backgroundColor = 'darkGray',
}) => {
    return (
        <div
            className={styles.section}
            style={{ backgroundColor: variables[backgroundColor as Variable] }}
        >
            <Container className={styles.content}>
                <div className={styles.logos}>
                    {(icons?.items ?? []).map(
                        ({ sys: { id }, action, image }) => {
                            const icon = image?.svgSource ? (
                                <Image
                                    src={image.svgSource}
                                    alt={image?.alt ?? ''}
                                    width={image.width ?? 340}
                                    height={image.height ?? 40}
                                    sizes='340px'
                                    className={styles.logo}
                                />
                            ) : null

                            if (!action || !('url' in action)) {
                                return (
                                    <div className={styles.link} key={id}>
                                        <Image
                                            src={icon?.props.src}
                                            alt={icon?.props.alt}
                                            width={icon?.props.width}
                                            height={icon?.props.height}
                                            sizes='340px'
                                            className={styles.logo}
                                        />
                                    </div>
                                )
                            }

                            return (
                                <RawAnchor
                                    key={id}
                                    href={action.url}
                                    target={id}
                                    className={styles.link}
                                >
                                    {icon}
                                </RawAnchor>
                            )
                        },
                    )}

                    {appStoreRating && numberOfReviews && (
                        <div className={styles.rating}>
                            <AppStoreRating
                                value={appStoreRating}
                                numberOfReviews={numberOfReviews}
                            />
                        </div>
                    )}
                </div>
            </Container>
        </div>
    )
}

export default SectionOfPressBanners
